import React from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import PasswordChange from "../components/AuthPages/Forgot_Password/PasswordChange";
import {
  authRoutes,
  investigatorRoutes,
  analyticsRoutes,
  manageDataRoute,
  configuration,
} from "./routeConstants";
import PageNotFound from "../components/PageNotFound";
// import VisualizationInterface from "../pages/visualization/query_interface/index";
import VisualizationInterface from "../pages/analytics/visualization/Visualization";
import Investigation from "../pages/investigationAnalysis/Investigation/index";
// import Logs from "../pages/administrator/AuditLogs";
import FilesPreview from "../pages/investigationAnalysis/FilesPreview";
import Review from "../pages/investigationAnalysis/review/index";
import ReviewList from "../pages/investigationAnalysis/review/List";
import NewLogsDashboard from "../pages/investigationAnalysis/NewAuditLogs/Dashboard";
import TaskStatusWidgetDashboard from "../pages/investigationAnalysis/NewTaskStatus";
import { useLocation } from "react-router-dom";
import Batches from "../pages/analytics/batches/Batches";
import AuditLogs from "../pages/analytics/auditTrail/index";
import Limit from "../pages/analytics/limit/Limit";
import Process from "../pages/analytics/process/Process";
import VisualizationList from "../pages/analytics/visualization/visualizationList";
import HomePage from "../pages/analytics/home/HomePage";
import ReportsPage from "../pages/analytics/reports/ReportsDashboard";
import NewReport from "../pages/analytics/reports/NewReport";
import ViewReport from "../pages/analytics/reports/ViewReport";
import OktaLogin from "../pages/okta/OktaLogin";
import UopList from "../pages/configuration/uop/UopList";
import ProductLIst from "../pages/configuration/product/ProdcutList";
import SiteList from "../pages/configuration/site/SiteList";
import ParamterList from "../pages/configuration/parameter/ParamterList";
import AuditList from "../pages/configuration/audit/AuditList";
import GenealogyReportListTable from "../pages/analytics/genealogy/list/GenealogyReportListTable";
import CreateGenealogyReport from "../pages/analytics/genealogy/newReport/CreateGenealogyReport";
import GenealogyReport from "../pages/analytics/genealogy/report/GenealogyReport";
// import Analytics from "../pages/analytics";
import Dashboard from "../pages/analytics/dashboard/Dashboard";

const AuthRoutes = () => {
  const navigate = useNavigate(); // Use useNavigate instead of withRouter
  return (
    <Routes>
      <Route
        path={`/${authRoutes?.forgotPassword}/:token?`}
        element={<PasswordChange navigate={navigate} />}
      />
      <Route path={`/*`} element={<PageNotFound />} />
      <Route path={`/${authRoutes.oktaLogin}`} element={<OktaLogin />} />
    </Routes>
  );
};

// const VisualizationRoutes = () => (
//   <Routes>
//     <Route
//       path={`/${analyticsRoutes?.visualizationInterface}`}
//       element={<VisualizationInterface />}
//     />
//   </Routes>
// );

const AnalyticsRoutes = () => (
  <Routes>
    <Route
      path={`/${analyticsRoutes?.visualizationInterface}`}
      element={<VisualizationInterface />}
    />

    {/* <Route path={`/${analyticsRoutes?.analytics}`} element={<Analytics />} /> */}
  </Routes>
);

const InvestigatorRoutes = () => (
  <>
    <Route
      path={`/${investigatorRoutes?.investigationAnalysis}`}
      element={<Investigation />}
    />

    <Route
      path={`/${investigatorRoutes?.logs}`}
      element={<NewLogsDashboard />}
    />

    <Route
      path={`/${investigatorRoutes?.taskStatus}`}
      element={<TaskStatusWidgetDashboard />}
    />

    <Route
      path={`/${investigatorRoutes?.filesPreview}`}
      element={<FilesPreview />}
    />
    {/* <Route path={`/${investigatorRoutes?.review}`} element={<Review />} /> */}

    <Route
      path={`/${analyticsRoutes?.visualizationInterface}`}
      element={<VisualizationList />}
    />

    <Route
      // path={`${analyticsRoutes?.visualizationInterface}/charts/:chartType/:mode?`}
      path={`${analyticsRoutes?.visualizationInterface}/charts/:mode?`}
      element={<VisualizationInterface />}
    />

    {/* <Route path={`/${analyticsRoutes?.analytics}`} element={<Analytics />} /> */}

    {/* <Route path="/" element={<Navigate to="/analytics/1/reports" />} /> */}
    <Route path={`/${manageDataRoute.reviewList}`} element={<ReviewList />} />
    <Route path={`/${manageDataRoute.reviewBatches}`} element={<Review />} />
    <Route path={`/${analyticsRoutes.analytics}/*`} element={<ReportsPage />} />
    {/* <Route path={`/${analyticsRoutes.newReport}/*`} element={<NewReport />} /> */}
    <Route
      path={`${analyticsRoutes?.reports}/:reprt/:mode?`}
      element={<NewReport />}
    />
    <Route path={`/${analyticsRoutes?.process}`} element={<Process />} />
    <Route path={`/${analyticsRoutes?.limit}`} element={<Limit />} />
    <Route path={`/${analyticsRoutes.batches}`} element={<Batches />} />
    <Route path={`/${analyticsRoutes.auditTrail}`} element={<AuditLogs />} />
    {/* <Route
      path={`/analytics/:productId/visualization/:chartType?`}
      element={<VisualizationInterface />}
    /> */}
    <Route path={`/${analyticsRoutes.viewReport}/*`} element={<ViewReport />} />
    {/* <Route
      path={`/${analyticsRoutes.genealogy}/`}
      element={<GenealogyReportListTable />}
    />
    <Route
      path={`/${analyticsRoutes.genealogy}/:mode`}
      element={<CreateGenealogyReport />}
    />
     <Route
      path={`/${analyticsRoutes.genealogyReport}`}
      element={<GenealogyReport />}
    /> */}
     <Route
      path={`/${analyticsRoutes.dashboard}`}
      element={<Dashboard />}
    />
  </>
);

const ConfigurationRoutes = () => (
  <>
    <Route path={`/${configuration?.productList}`} element={<ProductLIst />} />
    <Route path={`/${configuration?.uopList}`} element={<UopList />} />
    <Route path={`/${configuration?.siteList}`} element={<SiteList />} />
    <Route
      path={`/${configuration?.paramterList}`}
      element={<ParamterList />}
    />
    <Route path={`/${configuration?.auditList}`} element={<AuditList />} />
  </>
);

const RoutesChild = () => {
  const location = useLocation();

  if (
    location.pathname === `/${authRoutes.changePassword}` ||
    location.pathname === `/${authRoutes.oktaLogin}` ||
    location.pathname.startsWith(`/${authRoutes.forgotPassword}`)
  ) {
    return <AuthRoutes />;
  }
  switch (localStorage?.userSubRole) {
    case "srm_processor":
      return (
        <Routes>
          {InvestigatorRoutes()}
          <Route path={`/*`} element={<PageNotFound />} />
        </Routes>
      );
    case "srm_admin":
      return (
        <Routes>
          {InvestigatorRoutes()}
          {ConfigurationRoutes()}
          <Route path={`/*`} element={<PageNotFound />} />
        </Routes>
      );
    default:
      // return  <InvestigatorRoutes />
      return <PageNotFound />;
  }
};

export default RoutesChild;
